import { FaStarOfLife } from 'react-icons/fa';
import { CustomInput } from '../../../../../components/CustomInput';
import { useCustomTheme } from '../../../../../hooks/useCustomTheme';
import { Content, ToggleRow } from './styles';
import { InfoDescription } from '../../../../../components/InfoDescription';
import { CustomToggle } from '../../../../../components/CustomToggle';
import { useCompany } from '../../../../../hooks/useCompany';

export function Details({
  descricao,
  setDescricao,
  codigoPDV,
  setCodigoPDV,
  sequencia,
  setSequencia,
  disponivelCardapio,
  setDisponivelCardapio,
}) {
  const { theme } = useCustomTheme();
  const { company } = useCompany();

  return (
    <form>
      <Content>
        <div style={{ width: '100%' }}>
          <label htmlFor="descricao">
            <b style={{ color: theme.colors.textSecondary }}>
              Descrição <FaStarOfLife size={8} color="#FF0000" />
            </b>
          </label>
          <CustomInput type="text" value={descricao} onChange={setDescricao} />
        </div>

        <div style={{ flex: 1 }}>
          <label htmlFor="codigoPDV" style={{ marginTop: 10 }}>
            <b style={{ color: theme.colors.textSecondary }}>Codigo PDV</b>
          </label>
          <CustomInput
            type="number"
            value={codigoPDV}
            onChange={setCodigoPDV}
          />
        </div>

        <div style={{ flex: 1 }}>
          <label htmlFor="ativo" style={{ marginTop: 10 }}>
            <b style={{ color: theme.colors.textSecondary }}>
              Número de sequência
            </b>
          </label>
          <CustomInput
            type="number"
            min={1}
            value={sequencia || 0}
            onChange={setSequencia}
          />
        </div>

        {!!company.CardapioAtivo &&
          <ToggleRow>
            <InfoDescription
              label="Ativo no cardápio digital"
              description="Habilite para que o grupo apareça no cardápio do cliente.
              Desabilite para ocultar o grupo do cardápio, mas mantendo os itens ativos para venda no menucheff."
            />
            <CustomToggle
              id="cobrarMaior"
              checked={disponivelCardapio}
              onChange={() => setDisponivelCardapio((!disponivelCardapio))}
            />
        </ToggleRow>
        }
      </Content>
    </form>
  );
}
